// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__3ReTc","Block":"Toolbar_Block__2sPoV","CurrentPage":"Toolbar_CurrentPage__3807w","Title":"Toolbar_Title__RdIlJ"};